export const width=400;export const height=98.80439980870396;export default{width:width,height:height};